var _rect, _path, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialAppleSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 10,
    fill: "#333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.462 26.24c-.129.076-3.208 1.668-3.208 5.199.145 4.026 3.886 5.438 3.95 5.438-.064.076-.565 1.924-2.048 3.861-1.177 1.67-2.483 3.352-4.466 3.352-1.887 0-2.564-1.112-4.74-1.112-2.339 0-3 1.112-4.79 1.112-1.983 0-3.386-1.773-4.627-3.426-1.612-2.164-2.983-5.56-3.031-8.82-.033-1.727.323-3.425 1.225-4.868 1.274-2.014 3.547-3.38 6.03-3.426 1.903-.06 3.596 1.217 4.757 1.217 1.112 0 3.193-1.217 5.546-1.217 1.016.001 3.725.286 5.402 2.69zm-11.11-3.035c-.338-1.578.597-3.155 1.468-4.162C34.933 17.826 36.69 17 38.205 17c.097 1.578-.516 3.125-1.612 4.252-.983 1.217-2.676 2.133-4.24 1.953z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 63.5,
    height: 63.5,
    rx: 9.75,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}

export default SvgSocialAppleSquare;